module.exports = __webpack_public_path__ + "public/img/img_5.01a226ac.png";